// extracted by mini-css-extract-plugin
module.exports = {"loading":"aP","fullscreenWrapper":"aQ","centeredSpinner":"aR","rotation":"aS","withoutLayer":"aT"};